import {useCallback, useState} from 'react';
import qs from 'query-string';
import debug from 'debug';

const log = debug('circleblack:utils:useQueryObject');

const setQueryStringWithoutPageReload = qsValue => {
  const newurl = window.location.protocol + '//' + window.location.host + window.location.pathname + qsValue;

  window.history.pushState({path: newurl}, '', newurl);
};

const setQueryStringValue = (key, value, queryString = window.location.search) => {
  const values = qs.parse(queryString);
  const newQsValue = qs.stringify({...values, [key]: btoa(JSON.stringify(value))});
  setQueryStringWithoutPageReload(`?${newQsValue}`);
};

const getQueryStringValue = (key, queryString = window.location.search) => {
  const values = qs.parse(queryString);
  try {
    return values[key] !== undefined ? JSON.parse(atob(values[key])) : undefined;
  } catch (err) {
    log('key', key, 'values', values);
    log('Failed to parse value', err);
    return undefined;
  }
};

/**
 * Essentially the same as React.useState however it saves the value to the url, JSON Stringified and bases64 encoded, and initializes the value from it on refresh.
 * @param {String} key The query parameter name
 * @param {*} [initialValue] The value to initialize the variable to, must be able to be converged to JSON using JSON.stringify, only used if not provided in query params. If somehow the there is an error parsing the saved value, it returns undefined and logs the error using debug.
 * @return {*[]} The value and function to set value.
 */
function useQueryObject(key, initialValue) {
  const [value, setValue] = useState(getQueryStringValue(key) || initialValue);
  const onSetValue = useCallback(newValue => {
    setValue(newValue);
    setQueryStringValue(key, newValue);
  }, [key]);
  return [value, onSetValue];
}

export default useQueryObject;
